{
  "headerLogOut": "Log out",
  "navBarCustomersGeneral": "General",
  "cardProduct": "Card product",
  "companyCreditProduct": "Company credit product",
  "customersGeneralGeneralInfoHeading": "> \"\":[...]1 item",
  "companyNameLabel": "Company name",
  "addressLabel": "Address",
  "postalCodeLabel": "Postal code",
  "searchHeaderPlaceholder": "Search...",
  "customersCardOverviewAccountTypeDropdownLabel": "Account type",
  "customersCardOverviewAccountTypeDropdownLabelPlatinum": "Platinum",
  "customersCardOverviewAccountHeading": "Account",
  "customersCardOverviewAccountStatusBadge": "Status ok",
  "customersCardOverviewAccountSettledBalanceLabel": "Settled balance",
  "customersCardOverviewAccountSettledBalanceLabelValue": "-26 451 kr",
  "customersCardOverviewAccountAvailableToSpendLable": "Available to spend",
  "customersCardOverviewAccountAvailableToSpendLableValue": "-50 000 kr",
  "customersCardOverviewAccountCreditLimitLable": "Credit limit",
  "customersCardOverviewAccountCreditLimitLableValue": "23 549 kr",
  "customersCardOverviewAccountNameTitle": "Name:",
  "customersCardOverviewAccountNameInfo": "Card Account",
  "customersCardOverviewCorporateCustomerHeading": "Corporate customer",
  "notSubmittedBadge": "Not submitted",
  "overviewCorporateCustomerColumnCustomerRepresentative": "Customer representative:",
  "overviewCorporateCustomerCustomerColumnRepresentativeValue": "Nick Coloman",
  "overviewCorporateCustomerColumnRole": "Role:",
  "xxxxxxxxxxxxxxxxxxxxxxxxx": "XX-XXX XXX XX",
  "overviewCorporateCustomerColumnLocale": "Locale:",
  "overviewCorporateCustomerColumnLocaleValue": "sv_SE",
  "overviewCorporateCustomerColumnName": "Name:",
  "overviewCorporateCustomerColumnNameValue": "Mynt AB",
  "overviewCorporateCustomerColumnEmail": "Email:",
  "overviewCorporateCustomerColumnEmailValue": "info@mynt.se",
  "overviewCorporateCustomerColumnPhoneNumber": "Phone number:",
  "overviewCorporateCustomerColumnPhoneNumberValue": "XX-XXX XXX XX",
  "overviewCorporateCustomerColumnMobile": "Mobile:",
  "overviewCorporateCustomerColumnMobileValue": "XX-XXX XXX XX",
  "overviewCorporateCustomerColumnAdress1": "Adress 1:",
  "overviewCorporateCustomerColumnAdress1Value": "c/o Krongatan 1",
  "overviewCorporateCustomerColumnAdress2": "Adress 2:",
  "overviewCorporateCustomerColumnAdress2Value": "c/o Peng",
  "overviewCorporateCustomerColumnCity": "City:",
  "overviewCorporateCustomerColumnCityValue": "Boden",
  "overviewCorporateCustomerColumnZipCode": "Zip code:",
  "overviewCorporateCustomerColumnZipCodeValue": "XXX XX",
  "overviewCorporateCustomerColumnCountry": "Country:",
  "overviewCorporateCustomerColumnCountryValue": "SWE",
  "overviewCorporateCustomerColumnCustomerNumber": "Customer number:",
  "overviewCorporateCustomerColumnCustomerNumberValue": "xxxxxxxxxxxxxxxxxxxxxxxxx",
  "overviewCorporateCustomerColumnRegNo": "Reg. no:",
  "overviewCorporateCustomerColumnRegNoValue": "XXXXXX-XXXX_XXXXXXXXX",
  "customersCardOverviewCardHeading": "Cards",
  "customersCardOverviewCardsTableLableCardHolder": "Card holder",
  "customersCardOverviewCardsTableLableCardNumber": "Card number",
  "customersCardOverviewCardsTableLableStatus": "Status",
  "customersCardOverviewCardsTableLableTemplate": "Template",
  "customersCardOverviewCardsTableLableId": "ID",
  "customersCardOverviewCardsTableLableCardHolderValue": "Name Nameson",
  "customersCardOverviewCardsTableLableCardNumberValue": "XXXXXX______XXXX",
  "customersCardOverviewCardsTableLableStatusValue": "CARD_CLOSED",
  "customersCardOverviewCardsTableLableTemplateValue": "XXXXXXXXX",
  "customersCardOverviewCardsTableLableIdValue": "XXXXXXXXX",
  "customersCardOverviewPrivateCustomersHeading": "Private customers",
  "customersCardOverviewPrivateCustomersFirstName1Column": "First name:",
  "customersCardOverviewPrivateCustomersFirstName1ColumnValue": "Anna",
  "customersCardOverviewPrivateCustomersAdress1Column": "Adress 1:",
  "customersCardOverviewPrivateCustomersAdress1ColumnValue": "c/o Krongatan 1",
  "overviewPrivateCustomersColumnId": "ID:",
  "overviewPrivateCustomersColumnIdValue": "XXXXXXXXXX",
  "overviewPrivateCustomersColumnLocale": "Locale:",
  "overviewPrivateCustomersColumnLocaleValue": "sv_SE",
  "textCardOverviewPrivateCustomersMobileNumber": "Mobile:",
  "customersCardOverviewUsageLimitsHeading": "Usage limits",
  "customersCardOverviewUsageLimitsWeeklyHeading": "Weekly",
  "customersCardOverviewUsageLimitsTableLableCode": "Code",
  "customersCardOverviewUsageLimitsTableLableCount": "Count",
  "customersCardOverviewUsageLimitsTableLableSingleAmount": "Single amount",
  "customersCardOverviewUsageLimitsTableLableSumAmount": "Sum amount",
  "customersCardOverviewUsageLimitsTableLableCodeValue": "ALL",
  "customersCardOverviewUsageLimitsTableLableCountValue": "XXXXXXX",
  "customersCardOverviewUsageLimitsTableLableSingleAmountValue": "-",
  "customersCardOverviewUsageLimitsTableLableSumAmountValue": "-",
  "usageLimitsTableColumnHeadingCodeAtmValue": "ALL",
  "usageLimitsTableColumnHeadingCountAllValue": "XXXXXXX",
  "usageLimitsTableColumnHeadingSingleAmountAllValue": "-",
  "usageLimitsTableColumnHeadingSumAmountAllValue": "-",
  "Monthly": "Monthly",
  "tooltipEnablePlatinumAccountText": "Enable Platinum account, if you enable you can not go back to Prepaid account.",
  "cardsTableColumnHeadingCardHolder": "Card holder",
  "cardsTableColumnCardHolderValue": "Name Nameson",
  "cardsTableColumnCardNumberValue": "XXXXXX______XXXX",
  "cardsTableColumnCardStatusValue": "CARD_CLOSED",
  "cardsTableColumnTypeValue": "XXXXXXXXX",
  "cardsTableColumnIdValue": "XXXXXXXXX",
  "customersCardTransactionsTransactionsHeading": "Transactions",
  "customersCardTransactionsTableLableDate": "Date",
  "customersCardTransactionsTableLableVendor": "Vendor",
  "customersCardTransactionsTableLableAmount": "Amount",
  "customersCardTransactionsTableLableAccountId": "Account id",
  "customersCardTransactionsTableLableActions": "Actions",
  "tabSelected": "Vouchers",
  "customersCardTransactionsTableValue": "XXXX-XX-XX",
  "customersCardTransactionsVendorValue": "Facebook woods",
  "customersCardTransactionsTableAmountValue": "-XXXXX kr",
  "customersCardTransactionsTableAccountIdValue": "XXXXXXXXXX",
  "customersCardPayoutsPayoutsHeading": "Payouts",
  "customersCardPayoutsInputFieldAddTopUpValue": "10 000",
  "customersCardPayoutsInputFieldAddTopUpCurrency": "kr",
  "customersCardPayoutsInputFieldLabelAddTopUp": "Add top-up",
  "customersCardPayoutsTableLableDate": "Date",
  "customersCardPayoutsTableLableState": "State",
  "customersCardPayoutsTableLableCustomer": "Customer",
  "customersCardPayoutsTableLableAmmountSek": "Ammount SEK",
  "customersCardPayoutsTableLableExternalreference": "External reference",
  "customersCardPayoutsTableLableType": "Account type",
  "customersCardPayoutsTableLableEnfuceId": "Enfuce id",
  "customersCardPayoutsTableLableActions": "Actions",
  "customersCardPayoutsTableDropdownPlatinum": "Platinum",
  "customersCardPayoutsTableDropdownPrepaid": "Prepaid",
  "customersCardInvoicesTableDropdownAccountingMethodCash": "Cash method",
  "customersCardInvoicesTableDropdownAccountintMethodInvoice": "Invoice method",
  "customersCardCreditOnCardCreditSettingsHeading": "Credit settings",
  "creditOnCardCreditSettingsPrepaidHeading": "Prepaid",
  "customersCardCreditOnCardCreditSettingsPrepaidLabelCurrentCreditLimit": "Credit number:",
  "customersCardCreditOnCardCreditSettingsPrepaidCurrentCreditLimitValue": "12345",
  "customersCardCreditOnCardCreditSettingsPrepaidUpdateCredit": "Update credit",
  "customersCardCreditOnCardCreditSettingsPrepaidUpdateCreditLabelCreditState": "Credit state",
  "customersCardCreditOnCardCreditSettingsPrepaidUpdateCreditSetCreditState": "Set credit state",
  "customersCardCreditOnCardCreditSettingsPrepaidLableCreditLimit": "Credit limit",
  "customersCardCreditOnCardCreditSettingsPrepaidSetCreditLimit": "Set credit limit",
  "creditOnCardCreditSettingsPlatinumHeading": "Platinum",
  "customersCardCreditOnCardCreditSettingsPlatinumLabelCurrentCreditLimit": "Current credit limit",
  "customersCardCreditOnCardCreditSettingsPlatinumCurrentCreditLimitValue": "50 000 kr",
  "customersCardCreditOnCardCreditSettingsPlatinumUpdateCredit": "Update credit",
  "customersCardCreditOnCardCreditSettingsPlatinumUpdateCreditLabelCreditState": "Low balance alert status by costumer",
  "customersCardCreditOnCardCreditSettingsPlatinumUpdateCreditSetCreditState": "Set credit state",
  "customersCardCreditOnCardCreditSettingsPlatinumLableCreditLimit": "Credit limit",
  "customersCardCreditOnCardCreditSettingsPlatinumSetCreditLimit": "Set credit limit",
  "customersCardCreditOnCardCreditAgreementHeading": "Credit agreement",
  "creditAgreementSignatoriesPlaceholder": "Choose a signatory",
  "enablePlatinumAccountToggleTitle": "Enable Platinum account",
  "modaleEnablePlatinumAccountHeader": "Enable Platinum account",
  "modaleEnablePlatinumAccountText": "Are you sure you want to enable Platinum account? All future topups and card orders will be on the Platinum account. This cannot be reversed.",
  "modaleEnablePlatinumCancelButton": "Cancel",
  "modaleEnablePlatinumAcceptButton": "Yes, enable Platinum",
  "backofficeCustomersNavCard": "Card",
  "customersCardInvoicesCustomerInvoicesHeading": "Customer invoices",
  "customersCardInvoicesTableLableInvoice": "Invoice #",
  "customersCardInvoicesTableLableCraditNumber": "Credit number",
  "customersCardInvoicesTableLableState": "State",
  "customersCardInvoicesTableLableDate": "Date",
  "customersCardInvoicesTableLableDueDate": "Due date",
  "customersCardInvoicesTableLableType": "Type",
  "customersCardInvoicesTableLableCustomer": "Costumer",
  "customersCardInvoicesTableLableDebit": "Debit",
  "customersCardInvoicesTableLableCredit": "Credit",
  "customersCardInvoicesTableLableAccountType": "Accounting method",
  "customersCardInvoicesTableLableAction": "Actions",
  "customersCardInvoicesCustomerInvoicesCreditNumber": "Credit number:",
  "xxxxx": "12345",
  "invoiceInfoAccountingMethod": "Method",
  "invoiceInfoAccountingMethodValue": "Invoice method",
  "invoicesPDFHeading": "PDFs",
  "customersCardLowBalanceAlertHeading": "Low balance alert",
  "customersCardLowBalanceAlertSetLowBalanceAlertLimitHeading": "Set low balance alert limit",
  "x": "0",
  "customersCardLowBalanceAlertSetLowBalanceAlertLabelWhenBalanceFallsBelow": "When balance falls below",
  "customersCardLowBalanceAlertSetLowBalanceAlertStatusSwitchDeactivate": "Deactivate",
  "customersCardLowBalanceAlertSetLowBalanceAlertStatusSwitchActivate": "Activate",
  "customersCardAutoTopUpHeading": "Direct debit  - the view shoes 3 different scenarios.\nif there is no mandate agreements the section should collapse.\nAdd new icons to direct debit box for refresh and Cancel. Tooltip when hover.\nIf the checkbox for Send mandate agreement to customer is not checked (should be checked as default) then the modal with information “Are you sure” opens.",
  "customersCardAutoTopUpSetAutoTopUpLimitsHeading": "New direct debit connection",
  "XXXXXX": "123456789",
  "customersCardAutoTopUpLabelTopUpWithTheFollowinAmount": "Bank account number",
  "customersCardAutoTopUpButtonSetLimits": "Send",
  "customersCardAutoTopUpAutoTopUpDetailsHeading": "Direct debit details",
  "customersCardAutoTopUpAutoTopUpDetailsDirectDebitStatus": "Status",
  "customersCardAutoTopUpAutoTopUpDetailsDirectDebitStatusLabel": "Inactive",
  "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSet": "Auto top-up status set by customer",
  "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSetDeactivate": "Deactivate",
  "customersCardAutoTopUpAutoTopUpDetailsAutoTopUpStatusSetActivate": "Send mandate agreement to customer",
  "customersCardAutoTopUpAutoTopUpDetailsBankAccountNumber": "Bank account",
  "XXXX-XXXXXXXXXX": "XXXX-XXXXXXXXXX",
  "Typing|": "Typing|",
  "year": "Year",
  "month": "Month",
  "peReconGenerateAndSend": "Generate & Send",
  "peReconcilliationTooltipText": "Generate a monthly reconcilation report for a year and month and send it to PE Accounting. This will enforce a new report regardless of whether there already is an existing report for the month. However, not that as of March 2021, PE accepts but discards any duplicates, so it is not (yet) possible to send a correcting report",
  "generatedAt": "Generated at",
  "peReconYear": "Year",
  "peReconMonth": "Month",
  "peReconCreateId": "PE create_id",
  "peReconInfoHeader": "Info",
  "peReconInfoText": "Every month on the 4th at 23:00 we generate a monthly reconcilation report for every customer that has CardPartner=PE. The report is sent  to the PE system.\nThis view is for following up that reports were actually sent and in case a report failed it’s possible to trigger manually.\nNote that the system has a fallback on the 5th every month to catch any failures. System will not send duplicates.",
  "autoTopUpHeading": "Auto top-up",
  "autoTopUpSetLimitLabel": "Set auto top-up limits",
  "mFautoTopUpFallsBelowLabel": "When balance falls below",
  "mFautoTopUpToLabel": "Top up with the following amount",
  "autoTopUpSetLimitButton": "Set limits",
  "autoTopUpDetails": "Auto top-up details",
  "autoTopUpStatus": "Pending",
  "autoTopUp": "Auto top-up status",
  "autoTopUpDirectDebitApprovedStatus": "Approved",
  "autoTopUpDirectDebitApproved": "Direct debit status",
  "autoTopUpCustomerSetDetailsStatus": "Inactive",
  "autoTopUpCustomerSetDetails": "Auto top-up status set by customer",
  "DirectDebitDetailsBankAccountValue": "8732 40489238",
  "autoTopUpDetailsBankAccount": "Bank account number",
  "autoTopupHeading": "Autotopup",
  "lowBalanceAlertHeading": "Low balance alert",
  "lowBalanceAlertSetLabel": "Set low balance alert limit",
  "mFlowBalanceAlertSetLabel": "When balance falls below",
  "lowBalanceAlertSetButton": "Set",
  "accountMenuAutoTopUp": "Auto top-up",
  "accountMenuLowBalanceAlert": "Low balance alert",
  "lowBalanceAlertDetails": "Low balance alert details",
  "lowBalanceAlertText": "Low balance alert status set by customer",
  "lowBalanceAlertStatus": "Active",
  "directDebitHeading": "Direct debit",
  "DirectDebitDetailsStateValue": "Approved",
  "DirectDebitDetailsBankAccount": "Bank account",
  "DirectDebitDetailsState": "Status",
  "DirectDebitDetailsModifiedAtValue": "2021-03-01, 12:30",
  "DirectDebitDetailsModifiedAt": "Modifed at",
  "DirectDebitDetailsHeading": "Direct debit details",
  "enterBankAccountHeading": "Add bank account number",
  "mFenterBankAccountLabel": "Bank account number",
  "DirectDebitDetailsText": "Set the customers bank account number for direct debit",
  "enterBankAccountButton": "Set bank account",
  "backOfficeMenuCreditOnCard": "Credit on card",
  "backOfficeMenuInvoices": "Invoices",
  "paymentsHeading": "Billing overview",
  "paymentsDay": "Invoice date",
  "paymentPlanPaymentsDate1": "2021-04-03",
  "paymentPlanPaymentsDate2": "2021-03-03",
  "paymentPlanPaymentsDate3": "2021-02-03",
  "paymentsAmount": "Payment amount",
  "paymentsAmountNum": "15 241 kr",
  "paymentsRepayment": "Credit repayment",
  "paymentsRepaymentNum": "12 038 kr",
  "paymentsInterest": "Interest",
  "paymentsInterestNum": "3 203 kr",
  "paymentsStatus": "Status",
  "paymentPlanPaymentsStatus1": "Scheduled",
  "paymentPlanPaymentsStatus2": "Paid",
  "paymentsInvoicePDF": "PDF",
  "paymentsInvoicePDFDownload": "Invoice",
  "paymentsAction": "Actions",
  "Book": "Book",
  "Settle": "Settle",
  "Cancel": "Cancel",
  "oneTimeDirectDebitButton": "One-time direct debit top-up",
  "noDirectDebitActiveHeading": "Not possible to top-up the customers account right now because direct debit is not active.",
  "topUpAmountHeading": "How much to top-up?",
  "topUpAmountButton": "Top-up",
  "mFtopUpAmountLabel": "Top-up amount",
  "JSONData": "JSON data",
  "setCreditLimit": "Set max credit limit",
  "mFsetCreditLimitLabel": "Credit limit",
  "setCreditLimitButton": "Set credit limit",
  "creditRequestButton": "Clear request",
  "setCreditState": "Set credit state",
  "creditStateApproved": "Approved",
  "CreditDetailsCreditLimitNum": "50 000 kr",
  "CreditDetailsCreditUsedNum": "23 549 kr",
  "CreditDetailsCreditLimit": "Max credit limit",
  "CreditDetailsCreditUsed": "Credit used",
  "CreditDetailsCreditLeftNum": "26 451 kr",
  "CreditDetailsCreditLeft": "Credit available",
  "CreditDetailsHeading": "Credit details",
  "creditRequestText": "BlablaldkgdkfjdskfjdsfdBlablaldkgdkfjdskfjdsfdBlablaldkgdkfjdskfjdsfd",
  "dragAndDropFilesHeading": "Upload files",
  "dragAndDropFilesText": "Drag and Drop files here or",
  "dragAndDropFilesLink": "choose file",
  "accountSettingsAutoTopUpStatusPaused": "Paused",
  "accountSettingsAutoTopUpStatusActive": "Active",
  "AutoTopUpDetailsStatusValuePending": "Pending",
  "accountSettingsAutoTopUpStatusError": "Error",
  "accountSettingsAutoTopUpStatusInactive": "Inactive",
  "creditStateDenied": "Denied",
  "creditStateInactive": "Inactive",
  "mFsetCreditLimitError": "Add positive number less than 1 million",
  "invoiceInfoInvoiceDateValueError": "Please add a invoice date",
  "mFEnterInSEKError": "Please add the amount in SEK",
  "invoiceInfoDueDateValueError": "Please add a invoice date",
  "mFinvoiceDetailsCreditNumberError": "Please enter credit number",
  "mFinvoiceDetailsCustomerError": "Please enter customer",
  "mFinvoiceInfoCurrencyError": "Please choose currency",
  "mFinvoiceInfoPaymentMethodError": "Please choose payment method",
  "mFinvoiceInfoInvoiceDateError": "Please choose a invocie date on format YYYY-MM-DD",
  "mFinvoiceInfoDueDateError": "Please choose a due date on format YYYY-MM-DD",
  "mFinvoiceInfoDueDateAfterInvoiceDateError": "The due date has to be after the invoice date",
  "mFautoTopUpFallsBelowError": "Add positive number",
  "mFautoTopUpToError": "Add positive number",
  "mFlowBalanceAlertSetError": "Please enter the amount",
  "mFenterBankAccountError": "Add bank account number",
  "mFtopUpAmountError": "Choose your top-up amount",
  "mFreminderInvoiceError": "Please enter the penalty fee",
  "createInvoiceButton": "Create  invoice",
  "creditSettingsHeading": "Credit settings",
  "C": "C",
  "DC": "DC",
  "invoiceInfoHeading": "Invoice information",
  "invoiceInfoSettled": "Settled",
  "invoiceSpecHeading": "Specification",
  "invoiceSpecItemDetailsAmortization": "Amortization",
  "invoiceSpecItemDetailsAmortizationNum": "3 000 kr",
  "invoiceSpecItemDetailsInterest": "Interest",
  "invoiceSpecItemDetailsInterestNum": "1 500 kr",
  "invoiceSpecItemDetailsPenaltyFee": "Penalty fee",
  "invoiceSpecItemDetailsPenaltyFeeNum": "1 500 kr",
  "invoiceSpecItemDetailsInvoiceFee": "Invoice fee",
  "invoiceSpecItemDetailsInvoiceFeeNum": "1 500 kr",
  "invoiceSpecItemDetailsTotalSubTotalNum": "7 500 kr",
  "invoiceSpecItemDetailsTotalSubTotal": "Sub total",
  "invoiceSpecItemDetailsTotalVATAmountNum": "450 kr",
  "invoiceSpecItemDetailsTotalVATAmount": "VAT amount",
  "invoiceSpecItemDetailsTotalNum": "7 950 kr",
  "invoiceSpecItemDetailsTotal": "Total",
  "invoiceInfoRemainingAmountValue": "1 225 kr",
  "invoiceInfoPaidAmount": "Paid amount",
  "invoiceInfoRemainingAmount": "Remaining",
  "invoiceInfoLink": "Generate PDF",
  "accountingVouchersHeading": "Vouchers",
  "accountingVouchersBooking": "Bookings",
  "accountingVouchersBookingLink": "RI 124 \nC 234",
  "accountingVouchersPayment": "Payments",
  "accountingVouchersPaymentLink": "P 456 \nP 789 \nP 648",
  "invoiceTooltip": "Invoice - 2021-02-23",
  "invoiceInfo": "Invoice number",
  "invoiceInfoValue": "123",
  "invoiceInfoOCR": "OCR",
  "invoiceInfoOCRValue": "16606675",
  "invoiceInfoCustomer": "Customer",
  "invoiceInfoCustomerValue": "Peter Nilsson EF",
  "invoiceInfoType": "Type",
  "invoiceInfoTypeValue": "RepaymentInvoice",
  "invoiceInfoBookedDate": "Booked date",
  "invoiceInfoBookedDateValue": "2021-04-28",
  "invoiceInfoInvoiceDate": "Invoice date",
  "invoiceInfoInvoiceDateValue": "2021-05-01",
  "invoiceInfoDueDate": "Due date",
  "invoiceInfoDueDateValue": "2021-05-08",
  "invoiceInfoReminderDate": "Reminder date",
  "invoiceInfoReminderDateValue": "2021-05-10",
  "invoiceInfoReminderDueDate": "Reminder due date",
  "invoiceInfoReminderDateDueValue": "2021-05-17",
  "invoiceInfoSettledDate": "Settled date",
  "invoiceInfoSettledDateValue": "2021-05-17",
  "invoiceHistoryHeading": "Invoice history",
  "invoiceHistoryString": "BOOKED 2021-04-26, REMINDED 2021-05-10, DEBT_COLLECTION 2021-05-20, SETTLED 2021-05-30",
  "repaymentInvoicesHeading": "Repayment invoices",
  "invoiceInfoBooked": "Booked",
  "invoiceInfoDraft": "Draft",
  "invoiceInfoOverdue": "Overdue",
  "invoiceInfoDebtCollection": "Debt collection",
  "invoiceInfoReminder": "Reminder",
  "invoiceInfoCancelled": "Cancelled",
  "invoiceInfoCredited": "Credited",
  "createInvoiceHeading": "Create invoice",
  "invoiceDetailsCreditNumber": "Credit number",
  "mFinvoiceDetailsCreditNumberLabel": "123",
  "invoiceDetailsCustomer": "Customer",
  "mFinvoiceDetailsCustomerLabel": "Peter Nilsson EF",
  "mFinvoiceInfoInvoiceDateLabel": "Invoice date",
  "mFinvoiceInfoDueDateLabel": "Due date",
  "invoiceInfoCurrency": "Currency",
  "mFinvoiceInfoCurrencyLabel": "SEK",
  "invoiceInfoPaymentMethod": "Payment method",
  "mFinvoiceInfoPaymentMethodLabel": "Direct debit",
  "invoiceSpecificationHeading": "Invoice specification",
  "invoiceSpecItemDetails": "Item details",
  "invoiceSpecAmount": "Amount",
  "mFEnterInSEKLabel": "Enter in SEK",
  "draftInvoiceButton": "Draft  invoice",
  "reminderInvoiceHeading": "Send reminder invoice",
  "reminderInvoiceButtonSend": "Send",
  "mFreminderInvoiceLabel": "Penalty fee",
  "reminderInvoiceTopLabel": "Set penalty fee",
  "invoiceInfoTypeValueRepaymentInvoiceTableRow": "RI",
  "invoiceInfoTypeValueRequestForPaymentTableRow": "RFP",
  "invoiceDebtCollectionDate": "Debt collection date",
  "invoiceDebtCollectionDateValue": "2021-05-27",
  "invoiceSettledDate": "Settled date",
  "invoiceSettledDateValue": "2021-05-27",
  "featuresToggleDropDownButton": "Features",
  "featuresToggleOrderCard": "Order card",
  "featuresToggleReclaimCredits": "Reclaim credits",
  "featuresToggleMakeTopUps": "Make top-ups",
  "featuresToggleKYCLoop": "KYC loop",
  "tooltipDeleteCustomer": "Delete customer",
  "accountingInvoicesInvoices": "Invoice #",
  "invoicesInvoiceValue": "123",
  "accountingInvoicesState": "State",
  "invoicesStateValue": "Booked",
  "accountingInvoicesInvoiceDate": "Date",
  "invoicesInvoiceDateValue": "2021-04-03",
  "accountingInvoicesDueDate": "Due date",
  "invoicesDueDateValue": "2021-04-03",
  "accountingInvoicesType": "Type",
  "accountingInvoicesCustomer": "Customer",
  "invoicesCustomerValue": "Peter Nilsson AB",
  "accountingInvoicesInvoiceAmount": "Invoice amount",
  "invoicesInvoiceAmountValue": "15 241 kr",
  "accountingInvoicesRemaining": "Remaining ",
  "invoicesRemainingValue": "12 038 kr",
  "accountingInvoicesAction": "Action",
  "invoiceExternalReference": "External Reference",
  "invoiceExternalReferenceValue": "5144344722",
  "invoicesHeading": "Invoices",
  "accountingInvoicesToolTipBook": "Book",
  "accountingInvoicesToolTipCancel": "Cancel",
  "accountingInvoicesToolTipCredit": "Credit",
  "accountingInvoicesToolTipRemind": "Remind",
  "accountingInvoicesToolTipDebtCollection": "Debt collection",
  "registerExternalPaymentButton": "Register external payment\n",
  "registerPaymentHeading": "Register payment",
  "registerPaymentCustomerID": "Customer ID",
  "mFRegisterPaymentCustomerIDrLabel": "123",
  "registerPaymentOCR": "OCR",
  "mFRegisterPaymentOCRLabel": "OCR number",
  "registerPaymentAmount": "Amount",
  "mFRegisterPaymentAmountLabel": "Enter in SEK",
  "registerPaymentDate": "Payment date",
  "mFRegisterPaymentDateLabel": "Today’s date",
  "registerPaymentDecription": "Decription",
  "mFRegisterPaymentDecriptionLabel": "Info",
  "registerPaymentButton": "Register payment",
  "mFRegisterPaymentCustomerIDrError": "Customer ID is required field",
  "mFRegisterPaymentCustomerIDOrOCRError": "Please provide a customer ID or OCR number",
  "mFRegisterPaymentAmountError": "Payment amount is required field",
  "mFRegisterPaymentDateError": "Payment date is required field",
  "mFRegisterPaymentDecriptionError": "Payment description is required field",
  "mFRegisterPaymentAmountTypeError": "Amount must be a number",
  "mFOrderCardChoosePersonError": "Please choose a person",
  "mFOrderCardFullNameError": "Please enter the full name",
  "mFOrderCardCompanyError": "Please enter the company name",
  "mFOrderCardAddressError": "Please enter the address",
  "mFOrderCardZipError": "Please enter the postal code",
  "mFOrderCardCityError": "Please enter the city",
  "orderNewCardButton": "Order new card",
  "PlasticCardTableHeading": "Activate card",
  "transactionToolTipLatestNote": "Note",
  "activateCardTokenHeader": "Token code:",
  "activateCardTokenCode": "CSRR45",
  "activateCardTokenText": "Before activating the card, have you verified the \ntoken with the customer? (don’t reveal it yourself)",
  "activateCardYes": "Yes, activate card",
  "activateCardCancel": "Cancel",
  "orderNewCardModalHeading": "Order card",
  "orderNewCardModalPersonHeading": "Choose for which person",
  "mFOrderCardChoosePersonLabel": "Choose person",
  "orderNewCardModalAddressHeading": "Confirm or change the cards delivery info",
  "mFOrderCardFullNameLabel": "Full name",
  "mFOrderCardCompanyLabel": "Company name",
  "mFOrderCardAddressLabel": "Address",
  "mFInvoiceRecipientOrgLabel": "Apt, etc. (optional)",
  "mFOrderCardZipLabel": "Postal code",
  "mFOrderCardCityLabel": "City",
  "orderCardButton": "Order card",
  "cardStatusLabel": "Card status",
  "cardStatusLabelActive": "Active (CARD_OK)",
  "cardStatusLabelFrozen": "Frozen (CARD_BLOCKED)",
  "cardStatusLabelBlocked": "Blocked (SUSPECTED_FRAUD)",
  "cardStatusLabelTerminated": "Terminated (CARD_CLOSED)",
  "customerTableLableName": "Name",
  "customerTableLableNameValue": "Johan Obermayer",
  "customerTableLableSSN": "SSN",
  "customerTableLableSSNValue": "19790904-0177",
  "customerTableLableEmail": "Email",
  "customerTableLableEmailValue": "jakob@mynt.se",
  "customerTableLablePhoneNumber": "Phone number",
  "customerTableLablePhoneNumberValue": "+46735083074",
  "customerTableLableRoles": "Roles",
  "peopleChipAdmin": "ADMIN",
  "customerTableLableActions": "Actions",
  "deletedPeopleHeading": "Deleted people",
  "peopleHeading": "People",
  "addPersonButton": "Add person",
  "toolTipAreYouSureHeading": "Are you sure?",
  "toolTipAreYouSureCancel": "Cancel",
  "toolTipAreYouSureYes": "Yes",
  "companyNameHeading": "Accounting",
  "infoStatusProducts": "Products",
  "infoStatusKYC": "KYC",
  "infoStatusCardFeatures": "Card features",
  "infoStatusCardActivationStatus": "Card activation status",
  "editPersonTooltip": "Edit person",
  "sendEmailTooltip": "Send email",
  "sendSMSTooltip": "Send SMS",
  "removeUserTooltip": "Remove user",
  "sendInviteTooltip": "Send invite email",
  "loginAsUserTooltip": "Login as user",
  "errorBoxPersonActiveCards": "This person has active cards",
  "errorBoxPersonActiveCardsText": "It’s not possible to remove a person with active cards. Please remove cards before continue.",
  "errorBoxPersonExpenseApprover": "This person is an expense approver",
  "errorBoxPersonExpenseApproverText": "It’s not possible to remove a person that’s an expense approver for a team. Please remove the person as expense approver before continue.",
  "bookTooltip": "Book",
  "cancelTooltip": "Cancel",
  "creditTooltip": "Credit",
  "remindTooltip": "Remind",
  "debtCollectionTooltip": "Debt collection",
  "cardFeatuersLabel": "Card features",
  "orderCard": "Order card",
  "makeTopUps": "Make top-ups",
  "cardCreditProduct": "Card credit product",
  "approvalStatusLabel": "Approval status",
  "appovalStatusText": "Manually approved",
  "creditLimitLabel": "Credit limit",
  "companyCreditFeaturesLabel": "Company credit features",
  "reclaimCredit": "Reclaim credit",
  "addToCRMLink": "+ Add to CRM",
  "deleteCustomerLabel": "Delete customer",
  "churnCustomerLabel": "Churn customer",
  "GeneralInfoHeading": "General info",
  "orgNumberLabel": "Organisation number",
  "addressCoLabel": "Address co",
  "cityLabel": "City",
  "invoiceEmailLabel": "Invoice email",
  "phoneNumberLabel": "Phone number",
  "bankInfoHeading": "Bank info",
  "bankAccountLabel": "Bank account",
  "bankgiroLabel": "Bankgiro",
  "AccountingInfoHeading": "Accounting info",
  "accountingSystemLabel": "Accounting system (direct)",
  "acquisitionChannelHeading": "Acquisition channel",
  "channelLabel": "Channel",
  "cardPartnerHeading": "Card partner info",
  "cardPartnerLabel": "Card partner",
  "companyIDLabel": "Company ID",
  "companyTokenLabel": "Company token",
  "cardProductToolTipActiveStatus": "Token set",
  "companyTokenEdit": "Edit",
  "KYC": "KYC",
  "activationGuideLabel": "Activation guide",
  "cardProductToolTipNotActiveStatus": "Token not set",
  "companyOrgNum": "557213-1235",
  "cardProductToolTip": "Card product ",
  "CompanyCreditToolTip": "Company credit product",
  "KYCToolTipGreen": "KYC approved ",
  "KYCToolTipYellow": "KYC pending manual checks",
  "KYCToolTipRed": "KYC denied",
  "KYCToolTipGrey": "KYC not done",
  "KYCToolTipAnswered": "KYC answered",
  "orderCardToolTip": "Order card",
  "makeTopUpsToolTip": "Make top-ups ",
  "CardCreditProductToolTip": "Card credit product",
  "orderedCardToolTip": "Ordered card",
  "connectedAccountingToolTip": "Connected accounting",
  "cardCreditToolTip": "Approved card credit",
  "addedMoneyToolTip": "Added money",
  "madePurchaseToolTip": "Made purchase",
  "activationGuideIncomplete": "Incomplete",
  "activationGuideComplete": "Completed",
  "activationGuideHidden": "Hidden",
  "companyTokenSave": "Save",
  "toolTipAreYouSureTextCompanyToken": "A new company token will be set and send to the server",
  "toolTipAreYouSureYesDiscard": "Discard",
  "toolTipAreYouSureTextTransactionNotify": "This will send a transaction notification to the customer.\n",
  "toolTipAreYouSureTextDeleteTinkConnection": "This will delete Tink connection.",
  "toolTipAreYouSureSendKYCEmail": "This will send a KYC approved email to the customer.",
  "cardProductToolTipStatusManuallyApproved": "Manually approved",
  "cardProductToolTipStatusAutoApproved": "Auto approved",
  "cardProductToolTipStatusManuallyDenied": "Manually denied",
  "cardProductToolTipStatusAutoDenied": "Auto denied",
  "cardProductToolTipStatusPending": "Pending",
  "kycStatusSetStatus": "Set status",
  "kycStatusGreen": "- Approved",
  "kycStatusYellow": "- Pending manual checks",
  "kycStatusRed": "- Denied",
  "kycStatusGrey": "- Not answered",
  "kycRiskLevel": "Risk level",
  "kycRiskLevelLow": "Low",
  "kycRiskLevelNormal": "Normal",
  "kycRiskLevelHigh": "High",
  "kycRiskLevelUnacceptable": "Unacceptable",
  "KYCRefreshLabel": "Refresh owners and board members",
  "KYCRefreshButton": "Refresh",
  "kycStatusLabel": "Set KYC status",
  "kycRiskAssesmentLabel": "Risk assesment",
  "kycSendKycEmailButton": "Send KYC approved email",
  "accountingPayoutsToolTipBook": "Book",
  "accountingPayoutsToolTipCredit": "Settle",
  "accountingPayoutsToolTipCancel": "Cancel",
  "accountingPayoutsDate": "Date",
  "accountingPayoutsState": "State",
  "accountingPayoutsCustomer": "Customer",
  "accountingPayoutsAmount": "Amount (SEK)",
  "accountingPayoutsExternalReference": "External reference",
  "accountingPayoutsType": "Type",
  "accountingPayoutsActions": "Actions",
  "accountingPaymentsOCR": "OCR",
  "accountingPaymentsState": "State",
  "accountingPaymentsDate": "Date",
  "accountingPaymentsAmount": "Amount",
  "accountingPaymentsExternalSource": "External source",
  "accountingPaymentsExternalReference": "External reference",
  "accountingPaymentsActions": "Actions",
  "accountingYearsCreateYears": "Create year",
  "accountingAccountingCreateAccount": "Create account",
  "accountingVoucherCreateVoucher": "Create voucher",
  "tableLabel": "tableLable",
  "tableDetailInfoHeading": "tableDetailInfoHeading",
  "tableDetailsInfo": "tableDetailsInfo",
  "tableDetailsInfoSmallLable": "tableDetailsInfoSmallLable",
  "tableDetailInfoLink": "tableDetailInfoLink",
  "tooltipText": "tooltipText",
  "tableDetailInfoDesc": "tableDetailInfoDesc",
  "tableDetailsInfoValue": "tableDetailsInfoValue",
  "tableDetailInfoHistoryValue": "tableDetailInfoHistoryValue",
  "tableValue": "tableValue",
  "activationGuideToolTipNotStarted": "Not started",
  "activationGuideToolTipPending": "Pending",
  "activationGuideToolTipComplete": "Complete",
  "editAccountHeading": "Edit account",
  "editAccountNumberLabel": "Number",
  "editAccountNumberPlaceholder": "Choose a number",
  "editAccountNameLabel": "Name",
  "editAccountNamePlaceholder": "Choose a name",
  "editAccountAccountingYearLabel": "Accounting year",
  "editAccountAccountingYearPlaceholderDefault": "2021",
  "editAccountCurrencyLabel": "Currency",
  "editAccountCurrencyPlaceholderDefault": "SEK",
  "editAccountButtonCancel": "Cancel",
  "editAccountButtonSave": "Save",
  "editYearHeading": "Edit year",
  "editYearFromDateLabel": "From date",
  "editYearFromDateLabelPlaceholder": "Select a from date",
  "editYearToDateLabel": "To date",
  "editYearToDatePlaceholder": "Select a to date",
  "editYearNameLabel": "Name",
  "editYearNamePlaceholder": "Choose a name",
  "createYearNameDeafaultHeading": "Use as default year",
  "createYearNameDeafaultBody": "This year will be used as default when setting up new accounts",
  "createYearNameButtonCancel": "Cancel",
  "editYearButtonSave": "Save",
  "createYearHeading": "Create year",
  "createYearFromDateLabel": "From date",
  "createYearFromDateLabelPlaceholder": "Select a from date",
  "createYearToDateLabel": "To date",
  "createYearToDatePlaceholder": "Select a to date",
  "createYearNameLabel": "Name",
  "createYearNamePlaceholder": "Choose a name",
  "createYearNameButtonCreate": "Create",
  "createVoucherTransactionHeading": "Transactions",
  "editAccountNumberError": "Please enter a number",
  "editAccountNameError": "Please enter a name",
  "editAccountAccountingYearError": "Please select an accounting year",
  "editAccountCurrencyError": "Please select a currency",
  "createYearFromDateError": "Please select a from date",
  "createYearToDateError": "Please select a to date",
  "createYearNameError": "Please enter a name",
  "editYearFromDateError": "Please select a from date",
  "editYearToDateError": "Please select a to date",
  "editYearNameError": "Please enter a name",
  "voucherListAccountingYearLabel": "Accounting year",
  "voucherListAccountingDateLabel": "Accounting date\t",
  "voucherListDescriptionLabel": "Description",
  "voucherListNameLabel": "Name",
  "voucherListNumberLabel": "Number",
  "voucherListInBalanceLabel": "In balance",
  "voucherListPeriodLabel": "Period",
  "voucherListOutBalanceLabel": "Out balance",
  "voucherListAccountLabel": "Account",
  "voucherListDebitLabel": "Debit",
  "voucherListCreditLabel": "Credit",
  "yearsDefaultLabel": "Default",
  "voucherListTableText": "Table text",
  "createVoucherHeading": "Create voucher",
  "createVouchersAccountingYearPlaceholder": "Select a year",
  "createVouchersAccountingYearLabel": "Accounting year",
  "createVouchersAccountingDatePlaceholder": "Set an accounting date",
  "createVouchersAccountingDateLabel": "Accounting date",
  "createVouchersCurrencyPlaceholder": "SEK",
  "createVouchersCurrencyLabel": "Currency",
  "createVouchersDescriptionPlaceholder": "Add a description",
  "createVouchersDescriptionLabel": "Description",
  "createVoucherButtonCancel": "Cancel",
  "createVoucherButtonSave": "Save",
  "editVoucherHeading": "Edit voucher",
  "Label": "Choose a number",
  "createVouchersTransactionAccountLabel": "Account",
  "createVouchersTransactionDebitLabel": "Debit",
  "createVouchersTransactionCreditLabel": "Credit",
  "createVoucherAddNewTransactionLink": "Add new transaction",
  "vouchersAccountPlaceholder": "Choose an account",
  "vouchersAccountLabel": "Account",
  "vouchersYearPlaceholder": "Select a year",
  "vouchersYearLabel": "Year",
  "vouchersFromDatePlaceholder": "Set an date",
  "vouchersFromDateLabel": "From date",
  "vouchersToDatePlaceholder": "Set an date",
  "vouchersToDateLabel": "To date",
  "yearsHeading": "Years",
  "accountHeading": "Account",
  "vouchersHeading": "Vouchers",
  "createVouchersAccountingYearError": "Please select a year",
  "createVouchersAccountingDateError": "Please select a date",
  "createVouchersCurrencyError": "Please select a currency",
  "createVouchersDescriptionError": "Please add a description",
  "createVouchersSumEqualError": "Sum of debit must be equal credit",
  "createVouchersCreateTransactionError": "Please create transaction",
  "createVouchersAccountingAccountError": "Please add an account",
  "createVouchersDebitError": "Please add debit",
  "createVouchersCreditError": "Please add credit",
  "vouchersAccountError": "Please choose an account",
  "creditOnCardCreditSettingsHeading": "Credit settings",
  "DimitarTextkey": "dwwww",
  "creditSettingsCreditDetailsHeading": "Credit details",
  "creditSettingsMaxCreditLimitLabel": "Max credit limit",
  "creditSettingsMaxCreditLimitValue": "50 000 kr",
  "creditSettingsMaxCreditAvailableLabel": "Credit available",
  "creditSettingsMaxCreditAvailableValue": "26 451 kr",
  "creditSettingsMaxCreditUsedLabel": "Credit used",
  "creditSettingsMaxCreditUsedValue": "23 549 kr",
  "creditSettingsUpdateCreditHeading": "Update credit",
  "creditSettingsUpdateCreditLabel": "Credit state",
  "creditSettingsUpdateCreditPlaceholder": "Choose a credit state",
  "creditSettingsMaxCreditLimitPlaceholder": "Set credit limit",
  "creditOnCardCreditSettingsHeadingButtonUpdate": "Update credit",
  "creditAgreementHeading": "Credit agreement",
  "creditAgreementGetDataLink": "Get data",
  "creditAgreementDetailsHeading": "Credit agreement details",
  "creditAgreementStatusLabel": "Status",
  "creditAgreementAgreementIDLabel": "Agreement ID",
  "creditAgreementAgreementIDLink": "49485543",
  "creditAgreementSentDate": "Sent date",
  "creditAgreementSentDateValue": "March 15, 2022",
  "setUpCreditAgreementHeading": "Set up credit agreement",
  "setUpCreditAgreementAgreementDateLabel": "Agreement date",
  "creditAgreementCreditLimitPlaceholder": "Select a date",
  "setUpCreditAgreementCreditLimitLabel": "Credit limit",
  "setUpCreditAgreementCreditLimitPlaceholder": "Enter in SEK",
  "setUpCreditAgreementAnnualInterestRateLabel": "Annual interest rate",
  "setUpCreditAgreementAnnualInterestRatePlaceholder": "0",
  "setUpCreditAgreementFixedFeeLabel": "Fixed fee",
  "setUpCreditAgreementFixedFeePlaceoholder": "0",
  "setUpCreditAgreementPaymentMethodLabel": "Payment method",
  "setUpCreditAgreementPaymentMethodDefaultPlaceholder": "Autogiro",
  "setUpCreditAgreementIdentificationMethodLabel": "Identification method",
  "setUpCreditAgreementIdentificationMethodDefaultPlaceholder": "Swedish BankID",
  "setUpCreditAgreementPersonalGuarantorsLabel": "Personal guarantors",
  "creditAgreementGuarantorsPlaceholder": "Choose a personal guarantor",
  "setUpCreditAgreementSignatoriesLabel": "Signatories",
  "setUpCreditAgreementBankAccountLabel": "Bank account",
  "setUpCreditAgreementDirectDebitStatusLabel": "Direct debit status",
  "setUpCreditAgreementOtherTermsLabel": "Other terms",
  "setUpCreditAgreementOtherTermsPlaceholder": "Enter other terms",
  "companyGuarantorHeading": "Company guarantor",
  "companyGuarantorNameLabel": "Company name",
  "companyGuarantorNamePlaceholder": "Enter a company name",
  "companyGuarantorRegNumLabel": "Company reg. number",
  "companyGuarantorRegNumPlaceholder": "Enter reg. number for guarantor",
  "creditAgreementButtonSave": "Save",
  "creditAgreementButtonSend": "Send credit agreement",
  "creditRequestHeading": "Credit request",
  "creditRequestLink": "Clear request",
  "creditRequestBody": "I need 500 000 kr in credit to repair the washing machine",
  "earlierCreditAgreementHeadline": "Earlier sent credit agreements",
  "earlierCreditAgreementNumberLink": "49485543",
  "earlierCreditAgreementDate": "2021-04-16",
  "tabNotSelected": "Settings",
  "creditAgreementStatusSent": "Sent",
  "creditAgreementStatusPartialSigned": "Partial signed",
  "creditAgreementStatusFullySigned": "Fully signed",
  "exportHeading": "Transactions",
  "searchExportPlaceholder": "Search transaction...",
  "exportsFoundBadge": "XXX transactions found",
  "paginationResults": "Results: XXX - XXX of XXX",
  "paginationResultsAmount": "XXX",
  "paginationPagePrevInactive": "Prev",
  "paginationPageSelected": "1",
  "paginationPageNotSelected": "2",
  "exportActionBarDeselect": "...",
  "paginationPageNext": "Next",
  "transactionDate": "2023-07-04",
  "transactionVendor": "Apple",
  "transactionAmount": "-123 000 kr",
  "transactionMemberCard": "Member & Card",
  "transactionStatusType": "Status / Type",
  "transactionAttestStatus": "Attest status",
  "transactionActions": "Actions",
  "exportPaymentDate": "2021-04-16",
  "exportVendorName": "Apple Inc.",
  "exportAmountSEK": "- 9 000 kr",
  "exportAmountUSD": "- 800 USD",
  "exportMemberName": "Johan Obermayer",
  "exportTeam": "0456 - Google Ads",
  "underReviewBadge": "Under review",
  "rejectedBadge": "Rejected",
  "approvedBadge": "Approved",
  "exportBadge": "Exported",
  "cancelledBadge": "Cancelled",
  "rejectedStatusTypeBadge": "Rejected",
  "settledBadge": "Settled",
  "pendingBadge": "Pending",
  "cardCreditRepaymentBadge": "Card credit rep.",
  "unknownBadge": "Unknown",
  "topUpBadge": "Top-up",
  "creditUsageTopUpBadge": "Credit usage top-up",
  "accountSearchButton": "Search",
  "accountXAccountingAccaountAcountingVoucherNumberTitle": "accountXAccountingAccaountAcountingVoucherNumberTitle",
  "accountXAccountingAccaountAcountingVoucherDateTitle": "2021-04-03",
  "accountingInvoicesInvoiceDebit": "Debit",
  "accountingInvoicesCredit": "Credit",
  "BackOffice": "BackOffice",
  "headerInbox": "Inbox",
  "headerLeadCheck": "Lead check",
  "headerCustomers": "Customers",
  "headerCredits": "Credits",
  "headerBidding": "Bidding",
  "headerAccountX": "AccountX",
  "CustomerInvoicesTopupReference": "Topup reference: XXX",
  "customerInvoicesHeading": "Customer invoices",
  "directDebitTagPending": "Pending",
  "directDebitRefreshButton": "Refresh",
  "directDebitTagFail": "Fail",
  "directDebitTagApproved": "Approved",
  "directDebitTagRequested": "Requested",
  "dropDownLanguageFinnish": "Suomi",
  "dropdownLanguageEnglish": "English",
  "dropdownLanguageSwedish": "Svenska",
  "dropdownLanguageFigma": "Figma",
  "errorBoxYouAreOffline": "You’re offline",
  "errorBoxYouAreOfflineText": "Check you connection and try again.",
  "errorBoxPrivateBrowser": "Browser in private mode",
  "errorBoxPrivateBrowserText": "Change to normal mode to continue",
  "notificationBoxCopiedToClipboard": "Copied to clipboard",
  "notificationBoxInvite": "Invite successfully sent",
  "notificationBoxUploadReceipt": "Your receipt is uploaded",
  "errorBoxFallBelowValue": "Fall below value too low",
  "errorBoxFallBelowValueText": "Fall below value must be at least 5 000 kr",
  "errorBoxSomething": "Oops, something went wrong",
  "errorBoxSomethingText": "We’re working on it, try again later.",
  "lableGeneric": "GenericLabel",
  "errorGeneric": "GenericError",
  "placeholderGeneric": "GenericPlaceholder",
  "placeholderGenericDropdown": "GenericPlaceholderDropdown",
  "statusBadgePaused": "Paused",
  "statusBadgeActive": "Active",
  "statusBadgePending": "Pending",
  "statusBadgeError": "Error",
  "statusBadgeInactive": "Inactive",
  "GenericTertiaryButton": "GenericTertiaryButton",
  "GenericTertiaryButtonDisable": "GenericTertiaryButtonDisable",
  "textLinkInactive": "Freeze",
  "smallScreenInfoHeading": "We have too much to show you!",
  "smallScreenInfo": "Please come back when you’re on a desktop.",
  "autoTopUpModalformAddaNumber": "Add a number",
  "customersCardOverviewEnfuseAcccountHeading": "Enfuce account",
  "customersCardOverviewEnfuseCustomerEntityHeading": "Enfuce customer entity",
  "customersCardLowBalanceAlertSetLowBalanceAlertDetailsHeading": "Low balance alert details",
  "menuInboxDefault": "Inbox",
  "menuLeadCheckDefault": "Lead check",
  "menuCustomersDefault": "Customers",
  "menuCreditsDefault": "Credits",
  "menuBiddingDefault": "Bidding",
  "menuAccountingDefault": "Accounting",
  "menuInboxActive": "Inbox",
  "menuLeadCheckActive": "Lead check",
  "menuCustomersActive": "Customers",
  "menuCreditsActive": "Credits",
  "menuBiddingActive": "Bidding",
  "menuAccountingActive": "Accounting",
  "menuInboxHover": "Inbox",
  "menuLeadCheckHover": "Lead check",
  "menuCustomersHover": "Customers",
  "menuCreditsHover": "Credits",
  "menuBiddingHover": "Bidding",
  "menuAccountingHover": "Accounting",
  "accountSettingsAutoTopUpStatusRequested": "Requested",
  "statusBadgeRequested": "Requested",
  "headerSignOut": "Sign out",
  "cardCreditProductSendWelcomeEmail": "Send welcome email",
  "toolTipSendWelcomeEmailHeading": "Send welcome email",
  "toolTipSendWelcomeEmailText": "Are your sure you want to send\nthe customer an welcome email?",
  "toolTipSendWelcomeEmailButtonNo": "No",
  "toolTipSendWelcomeEmailButtonYes": "Yes",
  "tabSelectedInboxCredit": "Credit",
  "tabInboxCustomerSuccess": "Customer success",
  "tabInboxCreditAll": "All",
  "tabInboxCreditCardCreditRequest": "Card credit request",
  "tabInboxCreditCompanyCredit": "Company credit",
  "tabInboxCreditCardCreditRepaymentInvoice": "Card credit RI",
  "tabInboxCreditCompanyCreditRepaymentInvoice": "Company credit RI",
  "Default": "Default",
  "Modals": "Modals",
  "Icons": "Icons",
  "Active": "Active",
  "Selected": "Selected",
  "inboxTabCredit": "Credit",
  "inboxTabCustomerSuccess": "Customer success",
  "inboxTabMiscellaneous": "Miscellaneous",
  "inboxTabCreditAll": "All",
  "inboxTabCreditCardCreditRequest": "Card credit request",
  "inboxTabCreditCompanyCredit": "Company credit",
  "inboxTabCreditCardCreditRepaymentInvoice": "Card credit RI",
  "inboxTabCreditCompanyCreditRepaymentInvoice": "Company credit RI",
  "Show": "Show",
  "inputPlaceHolderSearchEvent": "Search event...",
  "inboxCreditLabelCardCreditRepaymentInvoice": "card_credit_RI",
  "inboxCreditCardCreditRepaymentInvoiceHeadingCompanyName": "Mynt AB",
  "inboxCreditCardCreditRepaymentInvoiceInformationStatus": "Repayment invoice overdue by - 5 days",
  "inboxCreditCardCreditRepaymentInvoiceAction": "Remind or collect debt",
  "inboxCreditLabelCardCreditRequest": "card_credit_request",
  "inboxCreditCardCreditRequestHeadingCompanyName": "Mynt AB",
  "inboxCreditCardCreditRequestInformationStatus": "OnboardingFlowInterestedForm",
  "inboxCreditCompanyCreditInformationAction": "Approve or deny",
  "inboxCreditCardCreditRequestInformationAmount": "SEK 10,000.00",
  "inboxCreditLabelCompanyCreditRepaymentInvoice": "company_credit_RI",
  "inboxCreditCompanyCreditRepaymentInvoiceHeadingCompanyName": "Mynt AB",
  "inboxCreditCompanyCreditRepaymentInvoiceInformationStatus": "[OVER_DUE], no reminders: 1, synced with fortnox",
  "inboxCreditCompanyCreditRepaymentInvoiceAction": "Remind or collect debt",
  "inboxCreditCompanyCreditRepaymentInvoiceInformationAmount": "SEK 6,750.00, credit no 1843",
  "inboxCreditLabelCompanyCredit": "company_credit",
  "inboxCreditCompanyCreditHeadingCompanyName": "Mynt AB",
  "inboxCreditCompanyCreditInformationStatus": "CUSTOMER_ACCEPTED ",
  "inboxCreditCompanyCreditAction": "Payout",
  "inboxCreditCompanyCreditInformationAmount": "SEK 125,000.00 ",
  "modalReminderSubHeadingPenaltyAmountsPlural": "Penalty amount for [8] companies",
  "modalReminderTextReminder": "Send reminder to all companies.",
  "modalReminderHeadingReminder": "Reminder",
  "modalReminderInputLabelPenaltyAmount": "Penalty amount",
  "modalReminderInputPlaceHolderPenaltyAmount": "500",
  "modalReminderInputCurrencyPenaltyAmount": "kr",
  "modalReminderButtonSubmit": "Submit",
  "modalSnoozeHeadingSnooze": "Snooze",
  "modalSnoozeInputLabelUntilDate": "Until date",
  "modalReminderInputPlaceHolderDate": "åååå-mm-dd",
  "modalSnoozeButtonSnooze": "Snooze",
  "modalCollectDebtHeadingAreYouSure": "Are you sure?",
  "modalCollectDebtTextAreYouSure": "Yes",
  "areYourSureCancelButton": "Cancel",
  "inboxTabCSS": "Customer success",
  "inboxTabCSSAll": "All",
  "inboxTabCSSEnfucePayout": "Enfuce payout",
  "inboxTabCSPeMonthlyReport": "PE monthly report",
  "inboxTabCSSCustomer": "Customer",
  "inboxTabCSSAutoTopUp": "Auto Top-up",
  "inboxTabCSSAutogiroApproval": "Autogiro approval",
  "inboxTabCSSRequestForPayment": "Request for payment",
  "inboxCSSLabelEnfucePayout": "enfuce_payout",
  "inboxCSSEnfucePayoutHeadingCompanyName": "Mynt AB",
  "inboxCSSEnfucePayoutAction": "Book or cancel",
  "inboxCSSEnfucePayoutInformationAmount": "SEK 5,000.00 ",
  "inboxCSSLabelPeMonthlyReport": "pe_monthly_report",
  "inboxCSSPeMonthlyReportInformationStatus": "Missing for 2022-December",
  "inboxCSSPeMonthlyReportAction": "Manually trigger a report",
  "inboxCSSLabelCustomer": "customer",
  "inboxCSSCustomerInformationStatus": "[PENDING]change products from [COMPANY_CREDIT, MULTI_INVOICE_CREDIT, CARD_CREDIT] to [COMPANY_CREDIT, MULTI_INVOICE_CREDIT, CARD, CARD_CREDIT]",
  "inboxCSSCustomerAction": "Approve or deny",
  "inboxCSSCustomerInformationAmount": "SEK 0.00",
  "inboxCSSLabelAutoTopUp": "auto_topup",
  "inboxCSSAutoTopUpAction": "Approve or deny",
  "inboxCSSAutoTopUpInformationAmount": "SEK 10,000.00 / 15,000.00",
  "inboxCSSLabelAutogiroApproval": "autogiro_approval",
  "inboxCSSAutogiroApprovalInformationStatus": "It’s been a few days and no approval has been received",
  "inboxCSSAutogiroApprovalAction": "Sent to Billecta Created",
  "inboxCSSAutogiroApprovalInformationAmount": "SEK 6,750.00, credit no 1843",
  "inboxCSSLabelRequestForPayment": "request_for_payment",
  "inboxCSSRequestForPaymentInformationStatus": "Overdue by -14 days",
  "inboxCSSRequestForPaymentAction": "Investigate",
  "inboxTabMiscAll": "All",
  "hoverBook": "Book",
  "hoverSnooze": "Snooze",
  "hoverDebtCollection": "Debt collection",
  "hoverSendReminder": "Send reminder",
  "snoozeDropDownOption01": "1 days",
  "snoozeDropDownOption02": "3 days",
  "snoozeDropDownOption03": "5 days",
  "snoozeDropDownOption04": "7 days",
  "snoozeDropDownOptionCustom": "Custom",
  "selectOptionShowAll": "Show all",
  "selectOptionShowSnoozed": "Show snoozed",
  "selectOptionShowStarred": "Show starred",
  "selectHoverSelectAll": "Select all",
  "customersGeneralSubscriptionHeading": "Subscription",
  "customersGeneralSubscriptionHeadingLabelPricingPlanOptionEssential": "Essential",
  "customersGeneralSubscriptionHeadingLabelPricingPlan": "Pricing plan",
  "inputFieldPlaceholder": "8293829",
  "setUpCreditAgreementPaymentMethodMobile": " Mobile",
  "rightMenuTransactionAddParticipantLink": "Add company guarantor",
  "creditOnCardAddCompanyGuarantor": "Add company guarantor",
  "transactionsFilterMenuHeadingFilter": "Filters",
  "transactionsFilterMenuApplyFilters": "Apply filters",
  "transactionsFilterMenuSubHeadingAccountType": "Account type",
  "transactionsFilterMenuSubHeadingCardHolders": "Card holders",
  "transactionsFilterMenuSubHeadingCards": "Cards",
  "transactionsFilterMenuSubHeadingStatus": "Status",
  "transactionsFilterMenuClear": "Clear",
  "transactionsFilterMenuSubHeadingAccountTypePlaceHolderSearchField": "Search account type...",
  "transactionsFilterMenuSubHeadingAccountTypeSelectAll": "Select all",
  "transactionsFilterMenuSubHeadingAccountTypeSelectPrepaid": "Prepaid ",
  "transactionsFilterMenuSubHeadingAccountTypeSelectPlatinum": "Platinum",
  "transactionsFilterMenuSubHeadingAccountTypeSelectViewAll": "View all...",
  "transactionsFilterMenuSubHeadingCardHoldersPlaceHolderSearchField": "Search card holders...",
  "transactionsFilterMenuSubHeadingCardHoldersSelectAll": "Select all",
  "transactionsFilterMenuSubHeadingCardHoldersSelectNameCardHolder": "Anders Jansson",
  "transactionsFilterMenuSubHeadingCardHoldersSelectViewAll": "View all...",
  "transactionsFilterMenuSubHeadingCardsPlaceHolderSearchField": "Search cards...",
  "transactionsFilterMenuSubHeadingCardsSelectAll": "Select all",
  "transactionsFilterMenuSubHeadingCardsSelectCardValueVirtual": "7587",
  "transactionsFilterMenuSubHeadingCardsSelectCardValueVirtualCardHolderName": "Anders Jansson",
  "transactionsFilterMenuSubHeadingCardsSelectCardValuePhysical": "7601",
  "transactionsFilterMenuSubHeadingCardsSelectCardValuePhysicalCardHolderName": "Anders Jansson",
  "transactionsFilterMenuSubHeadingCardsSelectViewAll": "View all...",
  "transactionsFilterMenuSubHeadingStatusPlaceHolderSearchField": "Search status...",
  "transactionsFilterMenuSubHeadingStatusSelectAll": "Select all",
  "transactionsFilterMenuSubHeadingStatusSelectApproved": "Approved",
  "transactionsFilterMenuSubHeadingStatusSelectViewAll": "View all...",
  "TransactionsFilterClearAll": "Clear",
  "searchTransactionPlaceholder": "Search transaction...",
  "transactionsFilterCalendar": "Jan 1 - May 5",
  "transactionsFilterFilters": "Filters",
  "transactionsFilterFiltersValueNumber": "3",
  "transactionsColumnLabelDate": "Date",
  "transactionsColumnLabelVendor": "Vendor",
  "transactionsColumnLabelAmount": "Amount",
  "transactionsColumnLabelCardHolder": "Card holder",
  "transactionsColumnLabelCard": "Card",
  "transactionsColumnLabelAccountType": "Account type",
  "transactionsColumnLabelTransactionStatus": "Transaction",
  "transactionsColumnLabelActions": "Actions",
  "transactionsColumnDateValue": "2021-04-16",
  "transactionsColumnVendorValue": "Github.com",
  "transactionsColumnAmountValueSek": "- 250 kr",
  "transactionsColumnAmountValueCurrency": "- 24 USD",
  "transactionsColumnCardHolderName": "Anna Rijkeboer",
  "transactionsColumnCardVirtualNumber": "7587",
  "transactionsColumnAccountTypePrepaid": "Prepaid",
  "transactionsColumnCardPhysicalNumber": "8383",
  "transactionsColumnAccountTypePlatinum": "Platinum",
  "transactionsFilterFiltersDefault": "Filters",
  "transactionExportAsCSV": "Download as list (CSV)",
  "transactionExportForExcel": "Download as list (Excel)",
  "transactionExportAsZip": "Download with image (ZIP)",
  "filterCalendarCalender7Days": "Last 7 days",
  "filterCalendar1Month": "Last month",
  "filterCalendar3Month": "Last 3 month",
  "filterCalendar12Month": "Last 12 month",
  "filterCalendarYearToDate": "Year to date",
  "filterCalendarAllTime": "All time",
  "filterCalenderDateFromActive": "03 / 01 / 2021",
  "filterCalenderDateToDefault": "03 / 04 / 2021",
  "filterCalenderMonth": "Januari 2023",
  "filterCalendarWeekDay01": "M",
  "filterCalendarWeekDay02": "T",
  "filterCalendarWeekDay03": "W",
  "filterCalendarWeekDay04": "T",
  "filterCalendarWeekDay05": "F",
  "filterCalendarWeekDay06": "S",
  "filterCalendarWeekDay07": "S",
  "filterCalendarDatePassed": "27",
  "filterCalendarDateFuture": "1",
  "filterCalendarDateActive": "3",
  "TransactionsDateFilterClear": "Clear",
  "filterCalenderDateToActive": "03 / 04 / 2021",
  "filterCalenderDateFromDefault": "03 / 01 / 2021",
  "filterCalenderYear": "2017",
  "filterCalenderYearActive": "2023",
  "customersGeneralSubscriptionHeadingLabelPricingPlanOptionPremium": "Premium",
  "invoiceInfoAccountingInvoiceInfoSpecificationSubscriptionFee": "Subscription fee",
  "invoiceInfoAccountingInvoiceInfoSpecificationSubscriptionFeeAmount": "780 kr",
  "invoiceInfoAccountingType": "Type",
  "invoiceInfoAccountingTypeSubscriptionFee": "SUBSCRIPTION_FEE",
  "invoicesCreateInvoiceDropdownLabelNamePaymentMethodCardAccount": "Card account",
  "invoicesCreateInvoiceDropdownCardAccountPlatinum": "Platinum",
  "invoicesCreateInvoiceVATCustomSelected": "Custom",
  "invoicesCreateInvoiceLabelCustomVAT": "Custom VAT amount",
  "invoicesCreateInvoiceLabelCustomVATValue": "00.00",
  "invoicesCreateInvoiceDropdownSubFee": "Subscription fee",
  "invoicesCreateInvoiceDropdownPaymentMethodCustomerMyntAccount": "Customer Mynt account",
  "invoicesCreateInvoiceDropdownPaymentMethodInvoice": "Invoice",
  "invoicesCreateInvoiceDropdownPaymentMethodAutogiro": "Autogiro",
  "invoicesCreateInvoiceDropdownPaymentMethodSEPADirectDebit": "SEPA Direct Debit",
  "invoicesCreateInvoiceDropdownCardAccountPrepaid": "Prepaid",
  "invoicesCreateInvoiceDropdownCurrencySEK": "SEK",
  "invoicesCreateInvoiceDropdownCurrencyEURO": "EURO",
  "invoicesCreateInvoiceHeading": "Create invoice",
  "invoicesCreateInvoiceSubHeadingCompanyName": "Chokladfabriken AB",
  "invoicesCreateInvoiceDropdownLabelNameInvoiceType": "Invoice type",
  "invoicesCreateInvoiceDropdownLabelNamePaymentMethod": "Payment method",
  "invoicesCreateInvoiceDropdownLabelNameCurrency": "Currency",
  "invoicesCreateInvoiceSubHeadingInvoiceSpecs": "Invoice specification",
  "invoicesCreateInvoiceDropdownLabelNameSubFee": "Subscription fee",
  "invoicesCreateInvoiceDropdownLabelNameSubFeeValueXXX": "780",
  "invoicesCreateInvoiceDropdownLabelNameSubFeeCurrencyXXX": "kr",
  "invoicesCreateInvoiceLabelNameVAT": "VAT 25 %",
  "invoicesCreateInvoiceVAT6": "6 %",
  "invoicesCreateInvoiceVAT12": "12 %",
  "invoicesCreateInvoiceVAT25Selected": "25 %",
  "invoicesCreateInvoiceVATCustom": "Custom",
  "invoicesCreateInvoiceLabelNameSubTotal": "Sub total",
  "invoicesCreateInvoiceLabelNameSubTotalValue": "780 kr",
  "invoicesCreateInvoiceLabelNameVATValue": "195 kr",
  "invoicesCreateInvoiceLabelNameTotal": "Total",
  "invoicesCreateInvoiceLabelNameTotalValue": "975 kr",
  "invoicesCreateInvoiceButtonCreateInvoice": "Create invoice",
  "invoicesCreateInvoiceLabelCustomVATValueValue": "00.00",
  "registerInvoicePaymentHover": "Cancel",
  "registerExternalPaymentHover": "Register external payment",
  "subscriptionFeeBelowZeroErrorLabel": "Fee cannot be below 0",
  "subscriptionFeeTypeErrorLabel": "Invalid fee",
  "subscriptionVatBelowZeroErrorLabel": "Vat cannot be below 0",
  "subscriptionVatTypeErrorLabel": "Invalid vat",
  "inputFieldLabelName": "Company ID",
  "tooltipTextRefreshAddress": "Refresh address",
  "areYourSureDeleteCustomerHeading": "Are you sure you want \nto delete customer?",
  "areYourSureDeleteCustomerText": "The customer can not be restored in the system",
  "areYourSureCancelDeleteCustomerButton": "Cancel",
  "areYourSureYesDeleteCustomerButton": "Yes",
  "enterBankAccountHeadingIBAN": "Add IBAN account number",
  "mFenterBankAccountLabelIBAN": "IBAN account number",
  "DirectDebitDetailsTextIBAN": "Set the customers IBAN account number for direct debit",
  "enterBankAccountButtonIBAN": "Set IBAN account number",
  "DirectDebitDetailsBankAccountIBAN": "IBAN",
  "mFenterIBANAccountError": "Add IBAN account number",
  "directDebitTagCancelled": "Cancelled",
  "directDebitTagPendingCancellation": "Pending Cancellation",
  "directDebitStatusLogHeading": "Direct debit Log",
  "directDebitLog": "xxx",
  "directDebitOpenAltarButton": "Open Altar",
  "directDebitCopyLogButton": "Copy",
  "directDebitTagReady": "Ready",
  "invoiceInfoAccountingInvoiceInfoSpecificationFixedCreditFee": "Fixed credit limit fee",
  "invoiceInfoAccountingInvoiceInfoSpecificationFixedCreditFeeAmount": "780 kr",
  "invoicesCreateInvoiceDropdownWithdrawal": "Withdrawal",
  "agreementIdLabelIBAN": "Agreement Id",
  "signingDateLabelIBAN": "Signing Date",
  "invoiceInfoAccountingInvoiceInfoSpecificationAdministrationFee": "Administration fee",
  "invoiceInfoAccountingInvoiceInfoSpecificationAdministrationAmount": "780 kr",
  "invoiceInfoAccountingInvoiceInfoShowAll": "Show all",
  "customersCardPayoutsTableBookedLabel": "Booked",
  "customersCardPayoutsTableLablePayoutType": "Type",
  "customersCardPayoutsTableLableSubtype": "Subtype",
  "menuTabBillingSettingsActive": "Billing settings",
  "billingSettingsHeading": "Billing settings",
  "billingSettingsPricingPlanHeading": "Pricing plan",
  "billingSettingsPricingPlanSubscriptionPlan": "Subscription plan",
  "billingSettingsPricingPlanSubscriptionPlanEssential": "Essential",
  "billingSettingsRecurringFeesHeading": "Recurring fees",
  "billingSettingsRecurringFeesSubscriptionFee": "Subscription fee",
  "billingSettingsRecurringFeesSubscriptionFeeAmount": "300",
  "billingSettingsRecurringFeesSubscriptionFeeCurrenncy": "kr",
  "billingSettingsOtherFeesHeading": "Other fees",
  "billingSettingsOtherFeesFxSurcharge": "FX Surcharge",
  "billingSettingsOtherFeesFxSurchargeValueOption1": "0%",
  "billingSettingsCashbackHeading": "Cashback",
  "billingSettingsCashbackCashback": "Cashback %",
  "billingSettingsCashbackCashbackValueOption1": "0%",
  "billingSettingsHoverResetSettings": "Reset to default",
  "billingSettingsHoverInfoValueEdited": "This value is edited from default value XXX",
  "billingSettingsHoverResetAllSettings": "Reset all settings to default",
  "billingSettingsModalHeadingAreYouSure": "Are you sure?",
  "billingSettingsModalTextResetAllValues": "You are about to remove all overrides. Pricing plan default settings will apply.",
  "billingSettingsModalButtonResetAllCancel": "Cancel",
  "billingSettingsModalButtonResetAllYes": "Yes, proceed",
  "billingSettingsModalTextResetSubscriptionFee": "You are about to remove this override. Pricing plan default setting will apply.",
  "billingSettingsModalButtonResetSubscriptionFeeCancel": "Cancel",
  "billingSettingsModalButtonResetSubscriptionFeeYes": "Yes, proceed",
  "billingSettingsPricingPlanSubscriptionPlanPremium": "Premium",
  "billingSettingsOtherFeesFxSurchargeValueOption2": "1.5%",
  "billingSettingsOtherFeesFxSurchargeValueOption3": "1.95%",
  "billingSettingsCashbackCashbackValueOption2": "0.5%",
  "billingSettingsCashbackCashbackValueOption3": "1%",
  "customersDirectDebitHeading": "Direct debit",
  "customersDirectDebitNewDirectDebitConHeading": "New direct debit connection",
  "customersDirectDebitNewDirectDebitConText": "Set the customers bank account number for direct debit",
  "customersDirectDebitNewDirectDebitConFieldLabel": "Bank account number",
  "customersDirectDebitNewDirectDebitCheckSendMandateAgreement": "Send mandate agreement to customer",
  "customersDirectDebitNewDirectDebitButtonSend": "Send",
  "customersDirectDebitMandateAgreementsHeading": "Mandate agreements",
  "customersDirectDebitDetailsHeading": "Direct debit details",
  "ATLAR": "ATLAR",
  "areYourSureHeading": "Are you sure?",
  "areYourSureSendMandateAlertText": "You are about to set up direct debit without sending a mandate agreement. This is not recommended.",
  "areYourSureSendMandateAlertButtonCancel": "Cancel",
  "areYourSureSendMandateAlertButtonYes": "Yes, proceed",
  "customersDirectDebitDetailsHoverTooltipCancel": "Cancel",
  "customersDirectDebitDetailsHoverTooltipRefresh": "Refresh",
  "vouchersCurrencyPlaceholder": "Choose a currency",
  "vouchersCurrencyLabel": "Currency",
  "invoiceInfoAccountingInvoiceInfoSpecificationCardsFee": "Cards fee",
  "invoiceInfoAccountingInvoiceInfoSpecificationTravelInsuranceFee": "Travel insurance fee",
  "invoiceInfoAccountingInvoiceInfoSpecificationCardOrderFee": "Card order fee",
  "customersCardCreditOnCardCreditSettingsPrepaidLableCreditLimitFeeRateLabel": "Credit limit fee rate",
  "customersCardCreditOnCardCreditSettingsPrepaidSetCreditLimitFeeRate": "Set credit limit fee rate",
  "customerCardCreditLimitFeeRateLabel": "Credit limit fee rate",
  "customerCardCreditLimitFeeRateValue": "Set credit limit fee rate",
  "createInvoiceHoverLabel": "Create invoice",
  "monthlySpendInfoOverview": "Spend this month 2592 kr ",
  "transactionName": "Johan Obermayer",
  "reservedBadge": "Reserved",
  "transactionTableId": "ID",
  "transactionTableIdValue": "123",
  "transactionTableExternalLinkId": "External link ID",
  "transactionTableExternalLinkIdValue": "123",
  "transactionTableOriginalAmount": "Original amount",
  "transactionTableOriginalAmountValue": "123",
  "transactionTableOriginalCardType": "Card Type",
  "transactionTableOriginalCardTypeValue": "123",
  "transactionTableCardType": "Card Type",
  "transactionTableCardTypeValue": "123",
  "transactionTableResponseCode": "Response code",
  "transactionTableResponseCodeValue": "123",
  "transactionTableConditionCode": "Condition code",
  "transactionTableConditionCodeValue": "123",
  "transactionTableType": "Transaction Type",
  "transactionTableTypeValue": "123",
  "billingSettingsNextBillingDate": "Next billing date",
  "billingSettingsNextBillingDateValue": "01 oct 2023"
}
